export const EXCHANGE_RATES_QUERY_KEYS = {
  all: ["EXCHANGE_RATES"] as const,
} as const;
